module.exports = __webpack_public_path__ + "static/media/2DGACM13.1772db16.jpg";